import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
const META_PIXEL_ID = '2187663168684313';
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // Avoid double-initialization
    if ((window as any).fbq) return;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', META_PIXEL_ID);
    (window as any).fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}